import styled, {css} from 'styled-components';
import { Colors } from '@brg/ui';

import { LayoutConst } from 'core/modules/layout.module';
import { TagsChildrenContainer, TagItemViewWrapper } from 'core/components/bTag/styles';
import hexToRGB from "shared/helpers/hexToRGB";

/**
 * Burgundy Tags Grid
 *
 * Сетка для тегов бургундии
 *
 */
const BTagsGrid = styled.div<{
  gap?: number;
  center?: boolean,
  scroll?: boolean,
  background?: string,
  isModalTags?: boolean,
  needProjectsTags?: boolean,
  isProjectPage?: boolean,
  isEmployeesPage?: boolean,
  isGroupList?: boolean,
  scrollHeight?: number,
}>`
  display: inline-flex;
  position: relative;
  flex-wrap: wrap;
  margin: 0 -${(p) => p.gap}px -${(p) => p.gap}px 0;
  width: calc(100% + ${(p) => p.gap}px);
  padding-left: 0;
  max-width: ${({ isProjectPage }) =>  isProjectPage ? '564px' : 'max-content'};
  max-height: ${p => p.scroll ? `${p.scrollHeight || 264}px` : 'none'};
  overflow-y: ${p => p.scroll ? 'scroll' : 'hidden'};
  justify-content: ${({ needProjectsTags }) => needProjectsTags ? 'center' : 'flex-start'};

  ${({ scroll }) => scroll && css`
    -webkit-overflow-scrolling: touch;
  `};
  
  overflow-x: hidden;
  justify-content: ${(p) => (p.center ? 'center' : null)};

  
  ${({gap, isModalTags}) => (isModalTags) ? css`
    min-width: calc(300px + ${gap}px);
  ` : null};
  
  &:after {
    content: '';
    position: sticky;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 35px;
    display: ${({ scroll, background }) => scroll && background ? 'inline-block' : 'none'};
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, ${p => p?.background ? hexToRGB(p?.background, 1) : ''} 100%);
  }

  // direction: ${p => p.scroll ? 'rtl' : 'ltr'};

  &::-webkit-scrollbar {
    height: 1px;
    width: 2px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
  }

  /* Не могу найти что и где меняет это правило, но отступ в модалке тегов из-за него поехал @Artem */
  // div:last-of-type {
  //   margin-bottom: 0 !important;
  // }

  & > * {
    margin: 0 ${(p) => p.gap}px ${(p) => p.isModalTags ? '16' : p.gap}px 0;
  }

  ${TagsChildrenContainer} {
   margin-bottom: 0 !important;

    ${TagItemViewWrapper} {
    margin-bottom: 16px !important;
    }
  }

  ${({ isProjectPage, scroll}) => isProjectPage ? css`
      max-height: ${scroll ? '162px' : 'none'} !important;
    ` : null};

    ${({ isGroupList, scroll}) => isGroupList ? css`
      max-height: 80px !important;
      overflow-y: ${scroll ? 'auto' : 'hidden'};
      max-width: 100%;
  ` : null};

  ${({ isModalTags }) => isModalTags && css`
    margin-bottom: 0px;
  `}

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    ${({ isProjectPage, scroll}) => isProjectPage ? css`
      max-height: ${scroll ? '120px' : 'none'} !important;
    ` :null};

    ${({ isGroupList, scroll}) => isGroupList ? css`
      max-height: 80px !important;
    ` : null};

    max-height: ${p => p.scroll ? '114px' : 'none'};
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ isProjectPage, scroll}) => isProjectPage ? css`
      max-width: 432px;
      padding-left: 0;
    ` :null};

    ${({ isGroupList, scroll}) => isGroupList ? css`
      max-width: 100%;
    ` : null};

    ${({ isModalTags }) => isModalTags ? css`
      margin-bottom: 0px;
    ` : css`
      margin-bottom: 8px;
    `};
    
    & > * {
      margin-right: 8px;
    }

  }

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    ${({ isGroupList, scroll}) => isGroupList ? css`
    max-height: ${scroll ? '80px' : 'none'} !important;
  ` : null};
  }
  
  @media(max-width: ${LayoutConst.screen.md}px) {

    ${({ isProjectPage, scroll}) => isProjectPage ? css`
      max-height: ${scroll ? '98px' : 'none'} !important;
    ` :null};
    
    ${({ isGroupList, scroll}) => isGroupList ? css`
    overflow-y: ${scroll ? 'scroll' : 'hidden'};
    max-height: ${scroll ? '70px' : 'none'} !important;
  ` : null};

    ${({ isProjectPage, scroll}) => isProjectPage ? css`
      max-width: calc(100% - 10px);
    ` :null};
  }
  

  @media (max-width: ${LayoutConst.screen.s}px) {
    ${({ isEmployeesPage }) => isEmployeesPage ? css`
      height: 73px;
      max-height: 73px;
      overflow-y: scroll;
      overflow-x: hidden;
    ` : null};

    margin-bottom: 0px;
    & > * {
      margin-bottom: 8px;
      margin-right: 4px;
    }
  }
`;

/**
 * tags grid props
 */
BTagsGrid.defaultProps = {
  gap: 8,
};

export { BTagsGrid };
import styled, {css} from 'styled-components';
import { Colors } from '@brg/ui';

import { LayoutConst } from 'core/modules/layout.module';
import { TagsChildrenContainer, TagItemViewWrapper } from 'core/components/bTag/styles';
import hexToRGB from "shared/helpers/hexToRGB";

/**
 * Burgundy Tags Grid
 *
 * Сетка для тегов бургундии
 *
 */
const BTagsGrid = styled.div<{
  gap?: number;
  center?: boolean,
  scroll?: boolean,
  background?: string,
  isModalTags?: boolean,
  needProjectsTags?: boolean,
  isProjectPage?: boolean,
  isEmployeesPage?: boolean,
  isGroupList?: boolean,
  scrollHeight?: number,
}>`
  display: inline-flex;
  position: relative;
  flex-wrap: wrap;
  margin: 0 -${(p) => p.gap}px -${(p) => p.gap}px 0;
  width: calc(100% + ${(p) => p.gap}px);
  padding-left: 0;
  max-width: ${({ isProjectPage }) =>  isProjectPage ? '564px' : 'max-content'};
  max-height: ${p => p.scroll ? `${p.scrollHeight || 264}px` : 'none'};
  overflow-y: ${p => p.scroll ? 'scroll' : 'hidden'};
  justify-content: ${({ needProjectsTags }) => needProjectsTags ? 'center' : 'flex-start'};

  ${({ scroll }) => scroll && css`
    -webkit-overflow-scrolling: touch;
  `};
  
  overflow-x: hidden;
  justify-content: ${(p) => (p.center ? 'center' : null)};

  
  ${({gap, isModalTags}) => (isModalTags) ? css`
    min-width: calc(300px + ${gap}px);
  ` : null};
  
  &:after {
    content: '';
    position: sticky;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 35px;
    display: ${({ scroll, background }) => scroll && background ? 'inline-block' : 'none'};
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, ${p => p?.background ? hexToRGB(p?.background, 1) : ''} 100%);
  }

  // direction: ${p => p.scroll ? 'rtl' : 'ltr'};

  &::-webkit-scrollbar {
    height: 1px;
    width: 2px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
  }

  /* Не могу найти что и где меняет это правило, но отступ в модалке тегов из-за него поехал @Artem */
  // div:last-of-type {
  //   margin-bottom: 0 !important;
  // }

  & > * {
    margin: 0 ${(p) => p.gap}px ${(p) => p.isModalTags ? '16' : p.gap}px 0;
  }

  ${TagsChildrenContainer} {
   margin-bottom: 0 !important;

    ${TagItemViewWrapper} {
    margin-bottom: 16px !important;
    }
  }

  ${({ isProjectPage, scroll}) => isProjectPage ? css`
      max-height: ${scroll ? '162px' : 'none'} !important;
    ` : null};

    ${({ isGroupList, scroll}) => isGroupList ? css`
      max-height: 80px !important;
      overflow-y: ${scroll ? 'auto' : 'hidden'};
      max-width: 100%;
  ` : null};

  ${({ isModalTags }) => isModalTags && css`
    margin-bottom: 0px;
  `}

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    ${({ isProjectPage, scroll}) => isProjectPage ? css`
      max-height: ${scroll ? '120px' : 'none'} !important;
    ` :null};

    ${({ isGroupList, scroll}) => isGroupList ? css`
      max-height: 80px !important;
    ` : null};

    max-height: ${p => p.scroll ? '114px' : 'none'};
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ isProjectPage, scroll}) => isProjectPage ? css`
      max-width: 432px;
      padding-left: 0;
    ` :null};

    ${({ isGroupList, scroll}) => isGroupList ? css`
      max-width: 100%;
    ` : null};

    ${({ isModalTags }) => isModalTags ? css`
      margin-bottom: 0px;
    ` : css`
      margin-bottom: 8px;
    `};
    
    & > * {
      margin-right: 8px;
    }

  }

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    ${({ isGroupList, scroll}) => isGroupList ? css`
    max-height: ${scroll ? '80px' : 'none'} !important;
  ` : null};
  }
  
  @media(max-width: ${LayoutConst.screen.md}px) {

    ${({ isProjectPage, scroll}) => isProjectPage ? css`
      max-height: ${scroll ? '98px' : 'none'} !important;
    ` :null};
    
    ${({ isGroupList, scroll}) => isGroupList ? css`
    overflow-y: ${scroll ? 'scroll' : 'hidden'};
    max-height: ${scroll ? '70px' : 'none'} !important;
  ` : null};

    ${({ isProjectPage, scroll}) => isProjectPage ? css`
      max-width: calc(100% - 10px);
    ` :null};
  }
  

  @media (max-width: ${LayoutConst.screen.s}px) {
    ${({ isEmployeesPage }) => isEmployeesPage ? css`
      height: 73px;
      max-height: 73px;
      overflow-y: scroll;
      overflow-x: hidden;
    ` : null};

    margin-bottom: 0px;
    & > * {
      margin-bottom: 8px;
      margin-right: 4px;
    }
  }
`;

/**
 * tags grid props
 */
BTagsGrid.defaultProps = {
  gap: 8,
};

export { BTagsGrid };
